import { useState, useEffect } from "react";
import { getSavedMethods } from "@/shared/api/payment";
import { type PaymentMethod } from "./types";
import { mapServerMethodToPaymentMethod } from "./mappers";

export const usePaymentMethods = () => {
  const [savedMethods, setSavedMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMethods = async () => {
      try {
        setLoading(true);

        const savedMethodsResponse = await getSavedMethods();
        const mappedSavedMethods = savedMethodsResponse.data.map(
          (serverMethod) => mapServerMethodToPaymentMethod(serverMethod)
        );
        setSavedMethods(mappedSavedMethods);
      } catch (e) {
        setError("Не удалось загрузить способы оплаты");
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    fetchMethods();
  }, []);

  return { savedMethods, loading, error };
};
